import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils copy/@reduxjs/toolkit';
import { MileStoneCategoryState, MilestoneCategoryInterface, visibleEnum } from '../types';
import { set } from 'lodash';
import { ActivityDayStatusEnum } from 'pages/milestoneList/types';

export const initialState: MileStoneCategoryState = {
  loading: false,
  editIndex: 0,
  isadd: false,
  pageNo: 1,
  pageSize: 10,
  totalRow: 0,
  search: '',
  list: [],
  form: {
    _id: '',
    id: '',
    englishTitle: '',
    hindiTitle: '',
    arabicTitle: '',
    visible: visibleEnum.visible,
    isActive: ActivityDayStatusEnum.ACTIVE,
    colorCode: '#000',
    order: 0
  },
  sortColumn: '',
  sortDir: '',
  englishTitle: []
};

export const useClinicSlice = createSlice({
  name: 'mileStoneCategoryState',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    updateFormValue: (state, action: PayloadAction<{ key: string; value: any }>) => {
      set(state, `form.${action.payload.key}`, action.payload.value);
    },
    clearForm: (state) => {
      state.form._id = '';
      state.form.id = '';
      state.form.arabicTitle = '';
      state.form.englishTitle = '';
      state.form.hindiTitle = '';
      state.form.isActive = ActivityDayStatusEnum.ACTIVE;
      state.form.visible = visibleEnum.visible;
      state.form.colorCode = '#000';
      state.form.order = 0;
    },
    doAdd: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doGetList: (state) => {},
    doGetEdit: (state, action: PayloadAction<string>) => {},
    doUpdate: (state, action: PayloadAction<{ callback: () => void }>) => {},

    setList: (state, action: PayloadAction<Array<MilestoneCategoryInterface>>) => {
      state.list = action.payload;
    },

    setSortColumn: (state, action: PayloadAction<string>) => {
      state.sortColumn = action.payload;
    },
    setSortDir: (state, action: PayloadAction<string>) => {
      state.sortDir = action.payload;
    },
    setDataForEdit: (state, action: PayloadAction<MilestoneCategoryInterface>) => {
      state.form = action.payload;
    },
    doGetMilestoneCategoryList: (state) => {},
    setEnglishTitleList: (state, action: PayloadAction<Array<MilestoneCategoryInterface>>) => {
      state.englishTitle = action.payload;
    }
  }
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
